<template>
  <div class="body flex flex-column">
    <div class="banner position-relative">
   
      <!-- video 框 -->
      <div id="body-back-video" :style="{'height':vdoHeight + 'px','margin-top':vdoMgt+ 'px'}" />
      <!-- video 框 -->

      <div class="position-absolute search">
        <div class="search-wrap">
          <div class="flex-row-align-center lib">
            <!-- 主LOGO 爱迪云馆藏 -->
            <span class="font-color-white font-size-60 font-bold">{{clients.clinetTitleMain}}</span>
          </div>
          <div class="search-input bg-white radius-clip-5">
            <div class="flex-1 input">
              <input class="font-size-16" :placeholder="collectionCountText" type="text" @input="inputChane" @keyup.enter="toSearch">
            </div>
            <div class="search-input-button radius-clip-5 bg-282B80 flex-center cursor " @click="toSearch">
              <img src="../../../../assets/icon-lib-search-sm.png">
              <span class="font-color-white font-size-16">搜索</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 特色专题 -->
    <div class="topic">
      <div class="topic-wrap">
        <div class="title flex flex-row-align-center ">
          <p class="font-size-30 font-bold">特色专题</p>
        </div>
        <div class="topic-list flex">
          <div v-for="(item,index) in topics" :key="index" class="topic-list-item flex-row-align-center bg-white cursor" @click="toSearchTopic(item)">
            <p class="topic-list-item-# font-color-999 font-size-14">#</p>
            <p class="topic-list-item-text font-size-14">{{ item.topicName }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 数字特藏 -->
    <div class="colletions">
      <div class="top-title flex-row-align-center flex-row-justify-space-between">
        <!-- 数字特藏 -->
        <p class="font-size-30 font-bold">{{clients.collectionTheme}}</p>
        <div class="flex-row-align-center cursor" @click="tosourcelist">
          <p class="font-color-264480 font-size-14">更多{{clients.collectionTheme}}</p>
          <img src="../../../../assets/icon-lib-foldup.png" alt="" style="transform: rotate(90deg);">
        </div>
      </div>
      <div class="colletions-list flex">
        <div v-for="(item,index) in colls" :key="index" class="colletions-list-item flex-shrink cursor" @click="toDetail(item)">
          <div class="position-relative colletions-list-item-img">
            <div class="img" :style="{backgroundImage: 'url(' + item.preview + ')','background-position':'center','background-size':'cover'}" />
            <div class="colletions-list-item-img-count flex-row-align-center position-absolute radius-clip-5">
              <div v-if="item.pictureNumber>0" class="space flex-row-align-center">
                <img src="../../../../assets/icon-lib-pic-count.png">
                <span class="font-color-white font-size-11">{{ item.pictureNumber }}</span>
              </div>
              <div v-if="item.videoNumber>0" class="space flex-row-align-center">
                <img src="../../../../assets/icon-lib-video-count.png">
                <span class="font-color-white font-size-11">{{ item.videoNumber }}</span>
              </div>
              <div v-if="item.audioNumber>0" class="space flex-row-align-center">
                <img src="../../../../assets/icon-lib-audio-count.png">
                <span class="font-color-white font-size-11">{{ item.audioNumber }}</span>
              </div>
              <div v-if="item.otherNumber>0" class="space flex-row-align-center">
                <img src="../../../../assets/icon-lib-file-count.png">
                <span class="font-color-white font-size-11">{{ item.otherNumber }}</span>
              </div>
            </div>
          </div>
          <div class="colletions-list-item-tit">
            <span class="font-size-16 font-color-264480 text-line-2 font-bold" style="line-height: 24px;">{{ item.collectionName }}</span>
          </div>
          <div class="colletions-list-item-des">
            <span class="font-size-14 font-color-666 text-line-3" style="line-height: 21px;">{{ item.description }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 展览 -->
    <div class="shows">
      <div class="shows-list flex">
        <!-- <div class="shows-list-item flex-shrink ">
          <div class="img radius-clip-5 cursor" :style="{backgroundImage: 'url(' + banner1 + ')','background-position':'center','background-size':'cover'}" @click="todetail(10)" />
        </div>
        <div class="shows-list-item flex-shrink ">
          <div class="img radius-clip-5 cursor" :style="{backgroundImage: 'url(' + banner2 + ')','background-position':'center','background-size':'cover'}" @click="todetail(3)" />
        </div> -->
        <!-- <div class="shows-list-item flex-shrink " >{{item.bannerImg}}</div> -->
         <div class="shows-list-item flex-shrink " v-for="(item, index) in banners" :key="index"> 
          <div class="img radius-clip-5 cursor" :style="{backgroundImage: 'url(' + item.bannerImg + ')','background-position':'center','background-size':'cover'}" @click="bannerLink(item)" />
        </div>
      </div>
    </div>

    <!-- 其他应用入口 -->
    <div class="related flex-row-align-center">
      <div class="related-list flex">
        <div v-for="(item,index) in users" :key="index" class="related-list-item flex-row-align-center radius-clip-5 cursor" @click="toSearchUser(item)">
          <div>
            <!-- <div class="img" /> -->
            <el-image class="img" :src="item.avatar" fit="cover">
              <div slot="error" class="image-slot flex flex-center">
                <img class="mach-width mach-height" src="https://libraryplus.bjadks.com/img/pic-default-40.png" alt="">
              </div>
            </el-image>
          </div>
          <div class="flex-column related-list-item-tits">
            <span class="font-color-264480 font-size-16 tit">{{ item.realName }}</span>
            <span class="font-size-12 font-color-999 des">发布 {{ item.collectionNumber }} 馆藏</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import flvjs from 'flv.js/dist/flv.min.js'
import DPlayer from 'dplayer'
import api from '../../../../api/home.js'
import commonapi from '../../../../api/common.js'
import searchModel from '../../../../models/search.js'
import user from '../../../../models/user.js'
import { replaceUrl } from '../../../../utils/utils.js'
// import navg from '../../../../components/NavigationBar.vue'
window.flvjs = flvjs

export default {
  name: 'Home',

  data() {
    return {
      dplayer: null,
      colls: null,
      topics: null,
      users: null,
      vdoHeight: 0,
      vdoMgt: 0,
      collectionCountText: '',
      banner1: 'https://img.libraryplus.bjadks.cn/library/1/20210408144512_9202.jpg',
      banner2: 'https://img.libraryplus.bjadks.cn/library/1/9243055c-5495-4889-8b92-1f6958a6721f.jpg',
      banners: null,
      clients:this.$store.getters.application
    }
  },
  watch:{
    clients(val){
      
    }
  },
  created() {
    this.requestbanner()
    this.request()
    const that = this
    setTimeout(() => {
      that.playbackvideo()
    }, 1000)

    this.vdoSet()
    replaceUrl()
  },
  mounted() {
    let that = this;
    window.onresize = this.vdoSet()
    this.$store.dispatch('navigation/setNavigatorIndex', 0)
    setTimeout(() => {
      that.clients = that.$store.getters.application  
    }, 1200);
  },
  methods: {
    vdoSet() {
      const that = this
      var docWid = window.innerWidth
      that.vdoHeight = docWid * 384 / 682 // 视频的宽高比
      that.vdoMgt = -((that.vdoHeight - 450) / 2)
      console.log('宽：' + window.innerWidth)
      console.log('高：' + that.vdoHeight)
      console.log('margin-top：' + that.vdoMgt)
    },
    //获取banner
    requestbanner() {
      const that = this 
      api.requestbanner({ tenantId:  this.$store.getters.tenantId }).then(r => {
        that.banners = r.data
      }).catch(err => {
        console.log(err)
      })     
    },
   
    request() {
      const that = this

      api.requestcoll({ tenantId:this.$store.getters.tenantId  }).then(r => {
        that.colls = r.data
      }).catch(err => {
        console.log(err)
      })
      api.requesttopic({ tenantId: this.$store.getters.tenantId  }).then(r => {
        that.topics = r.data
      }).catch(err => {
        console.log(err)
      })
      api.requestuser({ tenantId: this.$store.getters.tenantId  }).then(r => {
        that.users = r.data
      }).catch(err => {
        console.log(err)
      })
      commonapi.collectionCount({ tenantId: this.$store.getters.tenantId  }).then(r => {
        setTimeout(() => {
          that.collectionCountText = '在' + r.data + '条'+ that.clients.collectionTheme +'中检索'
          console.log('that.clients',that.clients)
        }, 1200);
      })
    },
    playbackvideo() {
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      this.dplayer = new DPlayer({
        container: document.getElementById('body-back-video'),
        autoplay: true,
        theme: '#23CEBC',
        loop: true,
        lang: 'zh-cn',
        screenshot: false,
        hotkey: false,
        preload: 'auto',
        mutex: true,
        playbackSpeed: [0.5],
        volume: 0,
        video: {
          url: require('../../../../assets/media/137042132-1.mp4'),
          type: 'mp4'
        }
      })
    },
    tosourcelist() {
      searchModel.viewData = { params: null, display: null, type: '' }
      this.$router.push({ name: 'Collection' })
    },
    toDetail(v) {
      const routeData = this.$router.resolve({
        name: 'Resource',
        query: {
          rsId: v.id,
          permission: v.permissionRange
        }
      })
      window.open(routeData.href, '_blank')
    },
    toSearch() {
      this.$store.dispatch('search/setType', 1)
      searchModel.viewData = { params: null, display: null, type: '' }
      this.$router.push({ name: 'Collection' })
    },
    inputChane(v) {
      this.$store.dispatch('search/setKeyword', v.target.value)
    },
    toSearchTopic(v) {
      this.$store.dispatch('search/setType', 1)
      this.$store.dispatch('search/setKeyword', '')
      searchModel.viewData = { params: { specialSubject: v.id }, display: v.topicName, type: 'specialSubject' }
      this.$router.push({ name: 'Collection' })
    },
    toSearchUser(v) {
      this.$store.dispatch('search/setType', 3)
      this.$store.dispatch('search/setKeyword', '')
      searchModel.viewData = { params: { commitBy: v.id }, display: v.realName, type: 'commitBy' }
      this.$router.push({ name: 'Collection' })
    },
    bannerLink(v) {
      // const routeData = this.$router.resolve({
      //   name: 'Resource',
      //   query: {
      //     rsId: v,
      //     permission: 1
      //   }
      // })
      // window.open(routeData.href, '_blank')
      window.open(v.bannerLink, '_blank')
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped></style>
<style scoped>
  .body {
    padding-top: 70px;
  }
  .body .banner {
    width:100%;
    height: 450px;
    font-size: 24px;
    overflow: hidden;
  }

  .body .banner .search {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
    padding: 128px 0 0 0;
  }

  .body .banner .search .search-wrap {
    margin:  0 auto;
    width: 1240px;
  }

  .body .banner .search .lib {
    height: 120px;
  }

  .body .banner .search .search-input {
    height: 50px;
    width: 550px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 7px;
  }

  .body .banner .search .search-input .input {
    padding: 0 13px;
  }

  .body .banner .search .search-input input {
    height: 100%;
    width: 100%;
    border: none;
  }

  .body .banner .search .search-input input:focus{
    outline: none;
  }

  .body .banner .search .search-input .search-input-button {
    width: 80px;
    height: 36px;
  }

  .body .banner .video img {
    width: 100%;
    height: 450px;
  }

  .body .topic {
    padding: 60px 0;
    background-color: #F3F4F9;
    font-size: 24px;
  }

  .body .topic .topic-wrap {
    margin: 0 auto;
    width: 1240px;
  }

  .body .topic .title {
    width: 1240px;
    height: 40px;
  }

  .body .topic .topic-list {
    margin-top: 35px;
    width: 1240px;
    flex-wrap: wrap;
  }

  .body .topic .topic-list .topic-list-item {
    height: 36px;
    padding: 10px 15px;
    border-radius: 18px;
    border: 1px solid rgba(26, 59, 128, 0.1);
    margin-bottom: 10px;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .body .topic .topic-list .topic-list-item .topic-list-item-text {
    margin-left: 4px;
  }

  .colletions {
    height: 510px;
    width: 1240px;
    margin: 0 auto;
  }

  .colletions .top-title {
    margin-top: 60px;
    height: 40px;
  }

  .colletions .colletions-list {
    flex-wrap: nowrap;
    overflow: hidden;
    margin-top: 30px;
  }

  .colletions .colletions-list .colletions-list-item {
    margin-right: 40px;
    width: 280px;
  }

  .colletions .colletions-list .colletions-list-item:last-child {
    margin-right: 0;
  }

  .colletions .colletions-list .colletions-list-item .colletions-list-item-img {
    width: 100%;
    height: 186px;
  }

  .colletions .colletions-list .colletions-list-item .colletions-list-item-img .img {
    width: 100%;
    height: 186px;
    background-color:antiquewhite;
    background-repeat: no-repeat;
    overflow: hidden;
    border-radius: 5px;
  }

  .colletions .colletions-list .colletions-list-item .colletions-list-item-img .colletions-list-item-img-count {
    bottom: 5px;
    right: 5px;
    height: 20px;
    padding: 0 9px 0 4px;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .colletions .colletions-list .colletions-list-item .colletions-list-item-tit {
    margin-top: 9px;
    height: 54px;
  }

  .shows {
    width: 1240px;
    height: 200px;
    margin: 0 auto;
  }

  .shows .shows-list {
    flex-wrap: nowrap;
  }

  .shows .shows-list .shows-list-item {
    width: 600px;
    height: 200px;
    margin-right: 40px;
  }

  .shows .shows-list .shows-list-item:last-child {
    margin-right: 0;
  }

  .shows .shows-list .shows-list-item .img {
    width: 100%;
    height: 100%;
    background-color: bisque;
  }

  .related {
    width: 1240px;
    height: 200px;
    margin: 0 auto;
  }

  .related .related-list {
    flex-wrap: nowrap;
  }

  .related .related-list .related-list-item {
    padding: 0 20px;
    width: 280px;
    height: 80px;
    border: 1px solid rgba(26, 59, 128, 0.1);
    margin-right: 40px;
  }

  .related .related-list .related-list-item:last-child {
    margin-right: 0;
  }

  .related .related-list .related-list-item .img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .related .related-list .related-list-item .related-list-item-tits {
    margin-left: 9px;
  }

  .related .related-list .related-list-item .related-list-item-tits .tit {
    height: 24px;
  }

  .related .related-list .related-list-item .related-list-item-tits .des {
    height: 20px;
  }

#body-back-video {
    width: 100%;
    height: 450px;
    overflow: hidden;
  }
  ::v-deep .dplayer-video-wrap{
    width:100%;
    height: 100%;
  }
  ::v-deep .dplayer-video-wrap video{
    width:100%;
    height: auto
  }

.colletions-list-item-tit,.colletions-list-item-des{
  letter-spacing: .5px;
}
 .colletions-list-item-img-count .space {
    margin-right: 4px;
  }

  .colletions-list-item-img-count .space:last-child {
    margin: 0;
  }
   /* .image-slot {
    width: 50px;
    height: 50px;
    background-image: url('https://libraryplus.bjadks.com/img/pic-default-40.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  } */

</style>
